export default "__VITE_ASSET__BvVejOR$__"